// extracted by mini-css-extract-plugin
export default {"container":"Tr-z","ratingLayout":"Ur-z","ratingLabel":"Vr-z","nonInteractiveRatingLabel":"Wr-z"};